<template>
  <div class="show-image">

   <div class="image-container" v-if="showImageUrl">
     <button class="modal-close is-large show-image-close-button" @click="onClose()"></button>
     <div class="image">
        <vue-load-image>
          <img slot="image" :src="showImageUrl" />
          <div slot="preloader" class="loading">
            <div class="pad">LOADING IMAGE</div>
            <fa icon="cog" size="2x" spin />
          </div>
          <div slot="error">Could not load image</div>
        </vue-load-image>
      </div>
   </div>

  </div>
</template>

<script>
import VueLoadImage from 'vue-load-image'

export default {
  components: {
    VueLoadImage
  },
  computed: {
    showImageUrl () { return this.$store.getters.showImageUrl }
  },
  methods: {
    onClose () {
      this.$store.dispatch('setShowImageUrl', null)
    }
  }
}
</script>

<style>
  .show-image {
    width: 100%;;
  }
  .show-image .image-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    z-index: 1000;
  }

  .show-image .image-container .image {
    width: 100%;
    height: 100%;
    overflow: auto;
    text-align: center
  }

  .show-image .image-container .image .loading {
    padding-top: 40vh;
    color: #ccc;
  }
</style>
